import React from 'react';

import { ButtonIcon } from 'components/button';

import Modal from './Modal';

const ModalClose = () => (
  <Modal.Consumer>
    {(context) => (
      <ButtonIcon
        className="close"
        transparent
        type="secondary"
        icon="close"
        onClick={context?.actions?.closeModal}
      />
    )}
  </Modal.Consumer>
);

export default ModalClose;
